import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "slots-auth" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "slots-auth-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: "/4444logo.png",
    alt: "4444"
  })
], -1)
const _hoisted_3 = { class: "slots-auth-container" }
const _hoisted_4 = { class: "slots-auth-content" }
const _hoisted_5 = { class: "slots-auth-content-info desktop" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "description" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "slots-auth-content-form desktop" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "form-fields" }
const _hoisted_13 = { for: "phone" }
const _hoisted_14 = { class: "line-wrap" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "select-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/flags/ua.png",
      alt: ""
    })
  ])
], -1)
const _hoisted_16 = { class: "mobile-wrap" }
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 0,
  class: "field-error"
}
const _hoisted_19 = { for: "password" }
const _hoisted_20 = { class: "line-wrap" }
const _hoisted_21 = { class: "under-fields checkbox-wrapper" }
const _hoisted_22 = { class: "form-line checkbox" }
const _hoisted_23 = {
  class: "label-check",
  for: "check1"
}
const _hoisted_24 = { class: "form-line checkbox" }
const _hoisted_25 = {
  class: "label-check",
  for: "check2"
}
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "form-line checkbox" }
const _hoisted_28 = {
  class: "label-check",
  for: "check3"
}
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_password_field = _resolveComponent("password-field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_modal_description = _resolveComponent("modal-description")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    true
      ? (_openBlock(), _createBlock(_component_Form, {
          key: 0,
          onSubmit: _ctx.onSubmit
        }, {
          default: _withCtx(({ errors }) => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("brand.name")), 1),
                    _createElementVNode("p", _hoisted_7, [
                      _createTextVNode(_toDisplayString(_ctx.$t("brand.description1")), 1),
                      _hoisted_8,
                      _hoisted_9,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("brand.description2")), 1)
                    ]),
                    _createElementVNode("button", {
                      class: "button btn-play",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showForm = true))
                    }, _toDisplayString(_ctx.$t("registration.registrationButton")), 1),
                    _createElementVNode("button", {
                      class: "button btn-more",
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal = true))
                    }, _toDisplayString(_ctx.$t("login.detailsButton")), 1)
                  ], 512), [
                    [_vShow, !_ctx.showForm]
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_10, [
                    _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t("registration.title")), 1),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-line", {'label-error': errors.phone || _ctx.customErrors.phone}])
                      }, [
                        _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("registration.login")), 1),
                        _createElementVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("input", {
                              class: "num",
                              type: "text",
                              value: _ctx.phoneCode,
                              readonly: ""
                            }, null, 8, _hoisted_17),
                            _createVNode(_component_Field, {
                              type: "tel",
                              id: "phone",
                              name: "phone",
                              rules: "required|digits:9",
                              onKeydown: _ctx.onPhoneKeyDown
                            }, null, 8, ["onKeydown"]),
                            (errors.phone || _ctx.customErrors.phone)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(errors.phone) + _toDisplayString(_ctx.customErrors.phone), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["form-line password", {'label-error': errors.password }])
                      }, [
                        _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("registration.password")), 1),
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_password_field, {
                            isConfirm: false,
                            errors: errors
                          }, null, 8, ["errors"])
                        ])
                      ], 2),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            name: "check1",
                            id: "check1",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ageAgreement) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.ageAgreement]
                          ]),
                          _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("registration.ageAgreement")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            name: "check2",
                            id: "check2",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rulesAgreement) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.rulesAgreement]
                          ]),
                          _createElementVNode("label", _hoisted_25, [
                            _createElementVNode("span", {
                              innerHTML: _ctx.$t('registration.rulesAgreement')
                            }, null, 8, _hoisted_26)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            name: "check3",
                            id: "check3",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataAgreement) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.dataAgreement]
                          ]),
                          _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("registration.dataAgreement")), 1)
                        ]),
                        _createElementVNode("button", {
                          class: "button registration",
                          disabled: _ctx.isSubmitButtonDisabled
                        }, _toDisplayString(_ctx.$t("registration.registrationButton")), 9, _hoisted_29),
                        _createElementVNode("button", {
                          class: "button log-in",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({ name: _ctx.ROUTES.LOGIN.name })))
                        }, _toDisplayString(_ctx.$t("registration.loginButton")), 1)
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.showForm]
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"]))
      : _createCommentVNode("", true),
    _createVNode(_component_modal_description, {
      show: _ctx.showModal,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showModal) = $event)),
      title: _ctx.$t('login.detailsTitle')
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", {
          innerHTML: _ctx.$t('login.details')
        }, null, 8, _hoisted_30)
      ]),
      _: 1
    }, 8, ["show", "title"])
  ], 64))
}